<template>
  <div>
    <b-modal
      id="modal-1"
      centered
      ok-title="Удалить"
      cancel-title="Отменить"
      title="Удаление"
      :distance="distance"
      @ok="deleteDistance(distance)"
    >
      <div v-if="distance">
        <span>
          Вы действительно хотите удалить дистанцию "{{ distance.name }}"?
        </span>
        <span v-if="comboDistances.length > 0">
          Дистанция будет автоматически удалена из всех комбо
        </span>
      </div>
    </b-modal>

    <!-- Модал закрытия/открытия регистрации -->
    <b-modal
      id="modal-close-registration"
      centered
      :ok-title="closingDistance && closingDistance.is_registration_closed ? 'Открыть регистрацию' : 'Закрыть регистрацию'"
      :ok-variant="closingDistance && closingDistance.is_registration_closed ? 'success' : 'danger'"
      cancel-title="Отмена"
      :title="closingDistance && closingDistance.is_registration_closed ? 'Открыть регистрацию на дистанцию' : 'Закрыть регистрацию на дистанцию'"
      @ok="confirmCloseRegistration"
      @hidden="closingDistance = null; closingComment = ''"
    >
      <div v-if="closingDistance">
        <p v-if="closingDistance.is_registration_closed">
          Вы уверены, что хотите <strong>открыть</strong> регистрацию на дистанцию
          <strong>"{{ closingDistance.name }}"</strong>?
        </p>
        <p v-else>
          Вы уверены, что хотите <strong>закрыть</strong> регистрацию на дистанцию
          <strong>"{{ closingDistance.name }}"</strong>?
        </p>
        <b-form-group
          v-if="!closingDistance.is_registration_closed"
          label="Комментарий (необязательно)"
          label-for="close-comment"
        >
          <b-form-textarea
            id="close-comment"
            v-model="closingComment"
            placeholder="Укажите причину закрытия регистрации..."
            rows="3"
          />
        </b-form-group>
      </div>
    </b-modal>

    <div
      style="width: 100%; position:relative; padding: 20px"
      class="p-6"
    >
      <div
        v-for="(sport, index) in select_kinds_sport"
        :key="'format' + index"
        class="sport-block"
      >
        <div
          :key="'form_' + index"
          class="flex items-center mt-2 mb-2"
        >
          <span>
            <div
              :id="`delete-tooltip-${index}`"
              class="d-inline-block"
              tabindex="0"
            >
              <b-button
                v-b-modal.modal-1
                title="Удалить"
                variant="flat-danger"
                class="btn-icon inline-block"
                size="sm"
                :disabled="disabled.includes(sport.uuid) || checkRegistrations(sport)"
                @click="deleteSport(sport, index)"
              >
                <feather-icon icon="MinusIcon" />
              </b-button>
            </div>
            <b-tooltip
              v-if="checkRegistrations(sport)"
              :target="`delete-tooltip-${index}`"
              position="top"
              triggers="hover"
            >
              В данной дистанции есть регистрации
            </b-tooltip>
            <strong>{{ sport.name }}</strong>
            <b-button
              variant="flat-warning"
              class="btn-icon inline-block"
              size="sm"
              @click="$bvModal.show('bv-modal-edit' + index)"
            >
              <feather-icon icon="InfoIcon" />
            </b-button>
            <b-button
              :variant="sport.is_registration_closed ? 'flat-success' : 'flat-secondary'"
              class="btn-icon inline-block close-reg-btn"
              size="sm"
              :title="sport.is_registration_closed ? 'Открыть регистрацию' : 'Закрыть регистрацию'"
              @click="openCloseRegistrationModal(sport)"
            >
              <feather-icon :icon="sport.is_registration_closed ? 'UnlockIcon' : 'LockIcon'" />
            </b-button>
            <b-button
              :variant="sport.is_hidden ? 'flat-warning' : 'flat-secondary'"
              class="btn-icon inline-block hide-distance-btn"
              size="sm"
              :title="sport.is_hidden ? 'Показать дистанцию' : 'Скрыть дистанцию'"
              @click="toggleHideDistance(sport)"
            >
              <feather-icon :icon="sport.is_hidden ? 'EyeOffIcon' : 'EyeIcon'" />
            </b-button>
            <span
              v-if="sport.related_distances"
              class="combo-label"
            >
              Комбо
            </span>
            <span
              v-if="sport.is_registration_closed"
              class="closed-label"
              :title="sport.registration_closed_comment || ''"
            >
              Регистрация закрыта<template v-if="sport.registration_closed_comment"> — {{ sport.registration_closed_comment }}</template>
            </span>
            <span
              v-if="sport.is_hidden"
              class="hidden-label"
            >
              Скрыта
            </span>
          </span>
        </div>
        <distance-modal-edit
          :sport="sport"
          :index="index"
          :age_groups="age_groups"
          :select_kinds_sport="select_kinds_sport"
          :start="start"
          :is-restricted="checkRegistrations(sport)"
          :schemeFile="schemeFile"
        />
      </div>
      <distance-modal-create
        :age_groups="age_groups"
        :select_kinds_sport="select_kinds_sport"
        :start="start"
      />
      <distance-modal-combo
        :select_kinds_sport="select_kinds_sport"
      />
      <b-button
        class="mt-3"
        variant="primary"
        @click="$bvModal.show('bv-modal-create')"
      >
        Добавить дистанцию
      </b-button>

      <b-button
        class="mt-3 ml-3"
        variant="primary"
        @click="$bvModal.show('bv-modal-combo')"
      >
        Добавить комбо
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BFormCheckbox,
  BFormInput,
  BFormRadio,
  BFormGroup,
  BFormTextarea,
  BModal,
  BRow,
  BTooltip,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import StartDays from '@/views/starts/StartDays'
import DistanceModalCreate from '@/views/starts/new-version/DistanceModalCreate'
import DistanceModalEdit from '@/views/starts/new-version/DistanceModalEdit'
import DistanceModalCombo from '@/views/starts/new-version/DistanceModalCombo.vue'

export default {
  name: 'MainForm',
  components: {
    StartDays,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    BFormGroup,
    BFormTextarea,
    BButton,
    BModal,
    flatPickr,
    BFormRadio,
    BTooltip,
    DistanceModalCreate,
    DistanceModalEdit,
    DistanceModalCombo,
  },
  props: ['start', 'select_kinds_sport', 'age_groups', "schemeFile"],
  data() {
    return {
      distance: null,
      comboDistances: null,
      index: null,
      disabled: [],
      closingDistance: null,
      closingComment: '',
    }
  },
  watch: {
    select_kinds_sport() {
      console.log('select_kinds_sport', JSON.parse(JSON.stringify(this.select_kinds_sport)))
    },
  },
  created() {
    if (this.start.disabledDistances) {
      this.disabled = this.start.disabledDistances.map(e => e.uuid)
    }
  },
  methods: {
    deleteSport(sport, index) {
      this.comboDistances = []
      if (this.start.distances) {
        this.start.distances.forEach(e => {
          if (e.related_distances && e.related_distances.includes(sport.uuid)) {
            this.comboDistances.push(e)
          }
        })
      } else {
        this.select_kinds_sport.forEach(e => {
          if (e.related_distances && e.related_distances.includes(sport.uuid)) {
            this.comboDistances.push(e)
          }
        })
      }
      this.distance = sport
      this.index = index
    },
    checkRegistrations(distance) {
      return !!(distance.registrationsCount > 0 || distance.comboRegistrationsCount > 0)
    },
    deleteDistance(distance) {
      if (this.comboDistances.length > 0 && this.start.distances) {
        this.start.distances.forEach((e, index) => {
          if (e.related_distances && e.related_distances.includes(distance.uuid)) {
            if (e.related_distances.length === 2) {
              this.start.distances.splice(index, 1)
            } else {
              const i = e.related_distances.indexOf(distance.uuid)
              e.related_distances.splice(i, 1)
            }
          }
        })
      }
      this.select_kinds_sport.splice(this.index, 1)
    },
    openCloseRegistrationModal(sport) {
      this.closingDistance = sport
      this.closingComment = sport.registration_closed_comment || ''
      this.$bvModal.show('modal-close-registration')
    },
    confirmCloseRegistration() {
      if (!this.closingDistance) return
      if (this.closingDistance.is_registration_closed) {
        this.$set(this.closingDistance, 'is_registration_closed', false)
        this.$set(this.closingDistance, 'registration_closed_comment', '')
      } else {
        this.$set(this.closingDistance, 'is_registration_closed', true)
        this.$set(this.closingDistance, 'registration_closed_comment', this.closingComment.trim())
      }
      this.closingDistance = null
      this.closingComment = ''
    },
    toggleHideDistance(sport) {
      this.$set(sport, 'is_hidden', !sport.is_hidden)
    },
  },
}
</script>

<style lang="scss" scoped>
.combo-label {
  border-radius: 5px;
  padding: 2px 5px;
  font-size: 11px;
  background-color: #ace8bb;
  color: #207936;
}
.closed-label {
  border-radius: 5px;
  padding: 2px 8px;
  font-size: 11px;
  background-color: #fde8e8;
  color: #c0392b;
  font-weight: 600;
  cursor: default;
}
.hidden-label {
  border-radius: 5px;
  padding: 2px 8px;
  font-size: 11px;
  background-color: #fff3cd;
  color: #856404;
  font-weight: 600;
  cursor: default;
  margin-left: 4px;
}
.close-reg-btn {
  margin-left: 2px;
}
.hide-distance-btn {
  margin-left: 2px;
}
.day-button{
  color: #ffffff;
  border-radius: 5px;
}
</style>
